import React, { memo } from 'react';

import cx from 'classnames';

import s from './index.module.css';
import { ILinkItemProps, IWrapperProps } from './types';

export const LinkItem = memo(({ link, onClick, activePageId, isHidden = false }: ILinkItemProps) => {
  const isEmptyItem = !link.name;
  const linkText = isEmptyItem ? 'Section Name' : link.navBarTitle || link.name;
  const isActive = link.id === activePageId;

  return (
    <div onClick={() => onClick(link.id)} className={cx(s.item, isActive && s.itemActive)}>
      <div className={s.itemBlock}>
        <Wrapper hidden={isHidden}>
          <div className={cx(s.link, isActive && s.linkActive, s.textBlock)}>{linkText}</div>
        </Wrapper>
      </div>
    </div>
  );
});

export const Wrapper = ({ hidden, children }: IWrapperProps) => {
  if (hidden) return <s data-block>{children}</s>;
  return <span data-block>{children}</span>;
};
